import { useNavigate } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "../../data/content";
import { Reveal } from "./Reveal";

export const CTABand = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="cta-band" className="surface-dark text-white py-20 lg:py-28">
      <div className="mx-auto w-[92%] max-w-[1280px] flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
        <div>
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-fc-cyan">Ready when you are</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-6xl max-w-2xl">
              Let’s get your comfort back.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-4">
            <button
              data-testid="cta-request-btn"
              onClick={() => navigate("/contact")}
              className="group inline-flex items-center gap-2 bg-white text-fc-ink px-7 py-4 font-semibold hover:bg-fc-ink hover:text-white transition-colors"
            >
              Request Service
              <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </button>
            <a
              data-testid="cta-call-btn"
              href={BUSINESS.phoneHref}
              className="inline-flex items-center gap-2 border border-white/40 hover:border-white px-7 py-4 font-semibold transition-colors"
            >
              <Phone size={16} /> {BUSINESS.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
